var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBankVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.023,
    y: 0.003,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#0EA546"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.388 2.639A9 9 0 012.66 15.367L15.388 2.639z",
    fill: "#027B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 6.543a.257.257 0 00-.172-.058h-1.285a2.07 2.07 0 00-.481-.92h1.75c.071 0 .129-.02.174-.058a.185.185 0 00.067-.147v-.652a.185.185 0 00-.067-.147.259.259 0 00-.173-.057H5.889c-.07 0-.128.019-.173.057a.185.185 0 00-.068.147v.85c0 .056.024.104.072.144.047.04.104.06.169.06h1.09c1.057 0 1.729.242 2.014.723H5.89c-.07 0-.128.02-.173.058a.185.185 0 00-.068.147v.652c0 .06.023.108.068.147a.257.257 0 00.173.057h3.21c-.11.35-.367.616-.77.8-.404.182-.937.274-1.598.274h-.842a.253.253 0 00-.17.06.183.183 0 00-.07.145v.811c0 .056.022.103.067.141.962.87 2.21 2.086 3.743 3.65a.238.238 0 00.188.077h1.466c.105 0 .178-.039.218-.115.05-.077.04-.15-.03-.218-1.463-1.525-2.613-2.667-3.45-3.426.852-.085 1.543-.32 2.074-.703.532-.383.855-.882.97-1.496h1.263c.07 0 .128-.019.173-.057a.184.184 0 00.067-.147V6.69a.184.184 0 00-.067-.147z",
    fill: "#fff"
  })));
}

export default SvgBankVerified;